export const ACTIONS = {
  TRIGGER_COMPLETION_CEREMONY_EVENT: 'TRIGGER_COMPLETION_CEREMONY_EVENT',
};

export const recordCompletionCeremony = data => dispatch => {
  dispatch({
    type: ACTIONS.TRIGGER_COMPLETION_CEREMONY_EVENT,
    payload: data,
  });
};
